import type { TFunction } from "i18next";

function titleCase(value: string): string {
  return value.charAt(0).toUpperCase() + value.slice(1);
}

/** Display label for fulfillment center batch configuration on the Batches settings page. */
export function formatBatchConfigurationDisplay(
  batchConfiguration: string | undefined,
  t: TFunction
): string {
  if (!batchConfiguration) {
    return "";
  }

  switch (batchConfiguration.toLowerCase()) {
    case "recurring schedule":
      return t("recurring");
    case "manual":
      return t("manual");
    case "calendar schedule":
      return t("calendar schedule");
    default:
      return batchConfiguration;
  }
}

/**
 * Display label for recurring-schedule order types. Uses existing translation keys
 * when available (e.g. fresh, shop); falls back to title-cased API value for
 * client-defined order types.
 */
export function formatOrderTypeDisplay(
  orderType: string | undefined,
  t: TFunction
): string {
  const trimmed = orderType?.trim();
  if (!trimmed) {
    return "";
  }

  return t(trimmed.toLowerCase() as "fresh", {
    defaultValue: titleCase(trimmed)
  });
}
